import React from 'react'
import { SaveCancel, FormDashboardTextarea } from '../../../components'

const NotificationFormPopup = ({onClose, isMobile}) => {
  const [form, setForm] = React.useState({
    message: '',
  })

  const updateForm = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    })
  }

  const handleClose = (e) => {
    e.preventDefault()
    e.stopPropagation()

    onClose(false)
  }

  return (
    <div
      className="fixed left-0 top-0 w-full h-screen flex justify-center items-center"
      style={{zIndex: 900, background: 'rgba(0, 0, 0, 0.75)'}}
      onClick={handleClose}
    >
      <div className="container mx-auto" onClick={(e) => e.stopPropagation()}>
        <div className="lg:w-8/12 mx-auto p-5 lg:p-8 bg-white rounded">
          <h1 className="text-lg lg:text-3xl font-primary font-bold">Buat Pemberitahuan</h1>
          <hr className="mt-5 mb-5 lg:mb-10"/>
          <p className="text-sm text-gray-444 mb-5">Agar tamu pendaftan mengetahui informasi perubahan tanggal ini. Kami sarankan untuk membuat catatan ...</p>
          <form>
            <FormDashboardTextarea
              className="w-full mb-6 lg:mb-8"
              placeholder="Tulis pesan"
              name="message"
              onChange={updateForm}
            />
            <SaveCancel onClick={handleClose} to="/dashboard/events/form" saveText="Publish"/>
          </form>
        </div>
      </div>
    </div>
  )
}

export { NotificationFormPopup }